import React from "react";
import "./style.scss";

const MyInput = (props: any) => {
  const {
    prefix = "",

    defaultValue = "",
    disabled = false,
  } = props;
  return (
    <>
      <div className="input-box">
        <span className="input__prefix sub-title">{prefix}</span>
        <span
          className={`input-input sub-title ${
            disabled ? "input-box--disabled" : ""
          }`}>
          {defaultValue}
        </span>
        {/* <Input
          required
          placeholder={placeholder}
          type={"textarea"}
          rows="2"
          // name={name}
          defaultValue={defaultValue}
          className={`sub-title ${disabled ? "input-box--disabled" : ""}`}
          onChange={onChange}
        />
        {suffix && suffix()} */}
      </div>
    </>
  );
};

export default MyInput;
